<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.pengingQas'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.qualitier"
            :placeholder="$t('receive.qualitier')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.createName"
            :placeholder="$t('returnBack.receiverName')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="
              $t('rules.startAt', [$t('returnBack.receiveAt')])
            "
            :end-placeholder="$t('rules.endAt', [$t('returnBack.receiveAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="qualityAt"
            :start-placeholder="$t('rules.startAt', [$t('receive.qualityAt')])"
            :end-placeholder="$t('rules.endAt', [$t('receive.qualityAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              type="primary"
              size="mini"
              @click="batchAction('batchQuality')"
            >
              {{ $t("action.quality") }}
            </el-button>

            <el-button
              v-if="
                Permit.extendModels().includes('wms') &&
                Permit.canActions('receiveQualityPush') &&
                Permit.currentTenant().config.invNeedPickPush
              "
              type="warning"
              size="mini"
              @click="batchAction('batchQualityPush')"
            >
              {{ $t("action.qualityAndPush") }}
            </el-button>

            <el-button
              v-if="
                !Permit.isFreeEdition() &&
                Permit.canActions('receiveQualityDelivery')
              "
              type="success"
              size="mini"
              @click="batchAction('batchQualityDelivery')"
            >
              {{ $t("action.qualityAndDelivery") }}
            </el-button>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="mgl10" @command="printQrcode">
              <el-button type="default" size="mini">
                {{ $t("action.printQrCode") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printQrcodeDiv"
                  >{{ $t("action.printQrCode") }}1</el-dropdown-item
                >
                <el-dropdown-item command="printQrcodeDiv2"
                  >{{ $t("action.printQrCode") }}2</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="receivesTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="associateSerialNo"
          :title="$t('stock.associateSerialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <span
              v-if="
                ['purchase', 'workOrder', 'order'].includes(row.associateType)
              "
              class="blue"
              @click="showRow(row)"
            >
              {{ row.associateSerialNo }}
            </span>
            <span v-else>{{ row.associateSerialNo }}</span>
            <div class="font10">
              {{ $t("text.type") }}：{{ $t("receiveTypes." + row.type) }}
              <span v-if="row.canQualityAndDeliver" class="green">
                (销售单)
              </span>
              <span v-else class="grey-shallow">
                <span v-if="['inventoryRework'].includes(row.type)">
                  ({{ $t("reworkTypes.inventory") }})
                </span>
                <span v-if="['returnBack'].includes(row.type)">
                  ({{ $t("menu.returnBacks") }})
                </span>
                <span
                  v-if="!['returnBack', 'inventoryRework'].includes(row.type)"
                >
                  ({{ $t("menu.replenishs") }})
                </span>
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            <el-popover
              v-if="
                row.otherInfoJson != null &&
                row.otherInfoJson != '' &&
                row.otherInfoJson != '[]'
              "
              placement="right"
              width="600"
              trigger="click"
            >
              <div
                v-for="(item, itemIdx) of JSON.parse(row.otherInfoJson)"
                :key="itemIdx"
                class="lineH24"
              >
                <span v-if="item.name != '供应商'">
                  {{ item.name }}：
                  <span v-if="['备注', '制作工艺'].includes(item.name)">
                    <raw-html :content="item.value" type="richText" />
                  </span>
                  <span v-if="item.name == '附件'">
                    <a
                      v-if="item.value"
                      class="fr blue"
                      target="_blank"
                      :href="item.value"
                    >
                      {{ $t("action.downloadAttatchment") }}
                    </a>
                  </span>
                  <span
                    v-if="!['备注', '制作工艺', '附件'].includes(item.name)"
                  >
                    {{ item.value }}
                  </span>
                </span>
              </div>
              <span slot="reference" class="popover-reference">
                {{ row.productNo }}
              </span>
            </el-popover>
            <span v-else> {{ row.productNo }} </span>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />
        <vxe-table-column :title="$t('receive.qualitier')" min-width="100">
          <template v-slot="{ row }">
            {{ row.qualitier }}
            <div class="font10">{{ row.qualityAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="qualityQuantity"
          :title="$t('receive.qualityQuantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.qualityQuantity }}
            <div v-if="row.storageShopName != null" class="font10">
              {{ $t("order.receiveShopName") }}:{{ row.storageShopName }}
            </div>
            <div v-if="row.voucher != null">
              <thumbnail-text :srcs="row.voucher" style="font-size: 8px" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="reworkQuantity"
          :title="$t('receive.reworkQuantity')"
          min-width="80"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="8"
              type="richText"
            />
            <div>
              <attribute :content="row.specJson" :number="6" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('text.handle')" min-width="80">
          <template v-slot="{ row }">
            {{ row.handler }}
            <div class="font10">{{ row.handleDept }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createName"
          :title="$t('returnBack.receiverName')"
          min-width="80"
        />
        <vxe-table-column
          field="createAt"
          :title="$t('returnBack.receiveAt')"
          width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="120"
          fixed="right"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.quantity > row.qualityQuantity + row.reworkQuantity"
            >
              <el-button type="text" size="mini" @click="qualityRow(row)">
                {{ $t("action.quality") }}
              </el-button>
              <el-button type="text" size="mini" @click="rework(row)">
                {{ $t("action.rework") }}
              </el-button>
            </span>
            <div>
              <el-dropdown>
                <el-button type="text" size="mini">
                  {{ $t("action.printQrCode") }}
                  <i class="el-icon-caret-bottom el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="printQrcodeDiv">
                    <span @click="printQrcodeRow('printQrcodeDiv', row)"
                      >{{ $t("action.printQrCode") }}1</span
                    >
                  </el-dropdown-item>
                  <el-dropdown-item command="printQrcodeDiv2"
                    ><span @click="printQrcodeRow('printQrcodeDiv2', row)"
                      >{{ $t("action.printQrCode") }}2</span
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('action.quality')"
      width="60%"
      v-if="batchQualityDF"
      :visible.sync="batchQualityDF"
      :close-on-click-modal="false"
    >
      <batch-quality
        :items="selectRecords"
        @close="batchQualityDF = false"
        @updateData="batchActionClose"
      ></batch-quality>
    </el-dialog>

    <el-dialog
      :title="$t('action.qualityAndPush')"
      width="60%"
      v-if="batchQualityPushDF"
      :visible.sync="batchQualityPushDF"
      :close-on-click-modal="false"
    >
      <batch-quality-and-push
        :items="selectRecords"
        @close="batchQualityPushDF = false"
        @updateData="batchActionClose"
      ></batch-quality-and-push>
    </el-dialog>

    <el-dialog
      :title="$t('action.qualityAndDelivery')"
      width="60%"
      v-if="batchQualityDeliveryDF"
      :visible.sync="batchQualityDeliveryDF"
      :close-on-click-modal="false"
    >
      <batch-quality-and-delivery
        :items="selectRecords"
        @close="batchQualityDeliveryDF = false"
        @updateData="batchActionClose"
      ></batch-quality-and-delivery>
    </el-dialog>

    <div id="printQrcodeDiv" style="display: none">
      <div
        v-for="(item, index) in selectRecords"
        :key="item.id"
        :style="{ 'page-break-before': index != 0 ? 'always' : '' }"
        align="center"
      >
        <table
          style="
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
            text-align: center;
            font-size: 12px;
          "
        >
          <tbody>
            <tr style="border: 1px solid #dfe5ec">
              <td align="center">
                <qrcode
                  v-if="item.associateSerialNo != null"
                  :value="item.associateSerialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
                <!-- :value="`${item.productNo}|${item.color}|${item.size}|${item.associateType}|${item.associateSerialNo}`" -->
              </td>
            </tr>
            <tr style="border: 1px solid #dfe5ec">
              <td>
                <div>{{ item.associateSerialNo }}</div>
                <div>{{ item.productNo }}</div>
                <div>{{ item.color }}-{{ item.size }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div id="printQrcodeDiv2" style="display: none">
      <div
        v-for="(item, index) in selectRecords"
        :key="item.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="margin-bottom: 5px">
          {{ item.associateSerialNo }}
        </div>
        <div style="margin-bottom: 5px">
          {{ item.productNo }}
        </div>
        <div style="margin-bottom: 5px">size：{{ item.size }}</div>
        <div style="margin-bottom: 5px">MADE IN CHINA</div>
      </div>
    </div>

    <!-- 单个质检 -->
    <el-dialog
      :title="$t('action.quality')"
      :visible.sync="qualityRowDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="qualityRowForm" :model="qualityRowObj" label-width="70px">
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model="qualityRowObj.quantity"
            :placeholder="qualityRowObj._maxQuantity"
          />
        </el-form-item>
        <el-form-item
          v-if="!Permit.isFreeEdition()"
          :label="$t('order.receiveShopName')"
          :prop="'shopId'"
          :rules="[
            {
              required: true,
              message: $t('rules.select', [$t('order.receiveShopName')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="qualityRowObj.shopId"
            :disabled="row.storageShopId == null ? false : true"
            clearable
            filterable
          >
            <el-option
              v-for="shop in shopsInv"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="qualityRowObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="qualityRowSubmitDoing"
          size="small"
          @click="qualityRowSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="qualityRowDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 返工 -->
    <el-dialog
      :title="$t('action.rework')"
      :visible.sync="reworkDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="reworkObjForm" :model="reworkObj" label-width="80px">
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model="reworkObj.quantity"
            :placeholder="reworkObj._maxQuantity"
          />
        </el-form-item>
        <el-form-item :label="$t('rework.remark')" :prop="'remark'">
          <el-input size="small" v-model="reworkObj.remark" type="textarea" />
        </el-form-item>
        <el-form-item
          :prop="'handOverAt'"
          :label="$t('text.handOverAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.handOverAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="reworkObj.handOverAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerTodayAfterTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('rework.voucher')" :prop="'voucher'">
          <dropzone v-model="reworkObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="reworkSubmitDoing"
          size="small"
          @click="reworkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="reworkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-purchase
        :id="currentRowId"
        v-if="['purchase'].includes(currentRowType)"
      />
      <show-order
        :id="currentRowId"
        v-if="['order', 'workOrder'].includes(currentRowType)"
      />
    </drawer>

    <el-dialog
      :title="$t('action.print')"
      :visible.sync="printQrcodeRowDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form label-width="80px">
        <div v-if="row != null" class="center gray mgb20">
          确定打印{{ row.associateSerialNo }}
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="printQrcodeRowSubmitDoing"
          size="small"
          @click="printQrcodeRowSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printQrcodeRowDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Qrcode from "@chenfengyuan/vue-qrcode";

import DateRange from "@/components/DateRange";
import ThumbnailText from "@/components/ThumbnailText";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";

import Quality from "@/api/quality.js";
import Shop from "@/api/shop.js";
import BatchQuality from "./batchQuality.vue";
import BatchQualityAndPush from "./batchQualityAndPush.vue";
import BatchQualityAndDelivery from "./batchQualityAndDelivery.vue";

import ShowPurchase from "@/views/lms/pendingReceives/showPurchase.vue";
import ShowOrder from "@/views/lms/pendingReceives/showOrder.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    ThumbnailText,
    RawHtml,
    Qrcode,
    Dropzone,
    BatchQuality,
    BatchQualityAndPush,
    BatchQualityAndDelivery,
    ShowPurchase,
    ShowOrder,
  },

  data() {
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      Util: Util,
      sorter: {
        sortBy: "qualities_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "qualities_productNo",
      },
      narrows: [
        [
          {
            label: this.$t("receive.qualityInfo"),
            items: [
              {
                label: this.$t("qualityInfos.yes"),
                key: "yes",
                condition: { quality: "yes" },
              },
              {
                label: this.$t("qualityInfos.no"),
                key: "no",
                condition: { quality: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.type"),
            items: Quality.types_all.map((type) => {
              return {
                label: this.$t("receiveTypes." + type),
                key: type,
                condition: { type: type },
              };
            }),
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        serialNo: null,
        productNo: null,
        color: null,
        size: null,
        qualitier: null,
        createName: null,
        qualityAtStartAt: null,
        qualityAtEndAt: null,
        createAtStartAt: null,
        createAtEndAt: null,
        handle: null,
      },
      //
      batchQualityDF: false,
      batchQualityPushDF: false,
      batchQualityDeliveryDF: false,
      // 单个质检
      shops: [],
      shopsInv: [],
      qualityRowDF: false,
      row: { storageShopId: null },
      qualityRowObj: {
        quantity: null,
        shopId: null,
        _maxQuantity: null,
        voucher: null,
      },
      qualityRowSubmitDoing: false,
      // 返工
      reworkDF: false,
      reworkObj: {
        quantity: null,
        _maxQuantity: null,
        remark: null,
        voucher: null,
        handOverAt: null,
      },
      reworkSubmitDoing: false,
      //
      currentRowId: null,
      currentRowType: null,
      showDF: false,
      //===
      printType: false,
      printQrcodeRowDF: false,
      printQrcodeRowSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
  },
  methods: {
    //
    showRow(row) {
      this.currentRowId = row.associateId;
      this.currentRowType = row.associateType;
      this.showDF = true;
    },
    // 返工
    rework(row) {
      const self = this;
      self.row = row;
      self.reworkObj.quantity =
        row.quantity - row.qualityQuantity - row.reworkQuantity;
      self.reworkObj._maxQuantity =
        row.quantity - row.qualityQuantity - row.reworkQuantity;
      self.reworkSubmitDoing = false;
      self.reworkDF = true;
    },
    reworkSubmit() {
      const self = this;
      this.$refs.reworkObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.reworkObj.quantity) ||
            self.reworkObj.quantity == "0" ||
            self.reworkObj.quantity > self.reworkObj._maxQuantity
          ) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.reworkObj.handOverAt = Util.formatDate(
            self.reworkObj.handOverAt
          );
          this.reworkSubmitDoing = true;
          Quality.rework(self.row.id, self.reworkObj).then(function (res) {
            if (res.status == 200) {
              self.reworkSubmitDoing = false;
              self.reworkDF = false;
              self.$message({
                message: self.$t("prompt.reworkSuccess"),
                type: "success",
              });
              self.loadData();
              self.$eventHub.$emit("qualityRework");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 质检
    qualityRow(row) {
      const self = this;
      self.row = row;
      self.qualityRowObj.quantity =
        row.quantity - row.qualityQuantity - row.reworkQuantity;
      self.qualityRowObj._maxQuantity =
        row.quantity - row.qualityQuantity - row.reworkQuantity;
      self.qualityRowObj.voucher = null;
      Shop.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.shops = res.data;
          self.shopsInv = res.data.filter((s) => s.isInventory === true);
        } else {
          self.sysError();
        }
        if (row.storageShopId !== null) {
          self.qualityRowObj.shopId = row.storageShopId;
        }
        self.qualityRowSubmitDoing = false;
        self.qualityRowDF = true;
      });
    },
    qualityRowSubmit() {
      const self = this;
      this.$refs.qualityRowForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.qualityRowObj.quantity) ||
            self.qualityRowObj.quantity == "0" ||
            self.qualityRowObj.quantity > self.qualityRowObj._maxQuantity
          ) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          // 免费版本
          if (self.Permit.isFreeEdition()) {
            self.qualityRowObj.shopId = self.shops[0].id;
          }
          //　收费版本
          if (!self.Permit.isFreeEdition()) {
            if (
              self.qualityRowObj.shopId == null ||
              self.qualityRowObj.shopId == ""
            ) {
              self.$message({
                message: this.$t("rules.select", [this.$t("menu.warehouses")]),
                type: "warning",
              });
              return;
            }
          }
          if (self.row.voucher != null) {
            self.qualityRowObj.voucher =
              self.row.voucher + ";" + self.qualityRowObj.voucher;
          }
          self.qualityRowSubmitDoing = true;
          Quality.quality(self.row.id, self.qualityRowObj).then(function (res) {
            if (res.status == 200) {
              self.qualityRowSubmitDoing = false;
              self.qualityRowDF = false;
              self.$message({
                message: self.$t("prompt.qualitySuccess"),
                type: "success",
              });
              self.loadData();
              self.$eventHub.$emit("qualityQuality");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //
    download(type) {
      const self = this;
      if (type === "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: this.selectRecords.map((c) => c.id),
        };
        this.downloadData(data);
      } else {
        if ((JSON.stringify(self.conditions) === "{}") === true) {
          this.$message.error(this.$t("prompt.downloadNoSearchCondition"));
          return;
        }
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Quality.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //
    printQrcode(type) {
      this.printFunction(type);
    },
    printQrcodeRow(cmd, row) {
      const self = this;
      self.selectRecords = [row];
      self.row = row;
      self.printType = cmd;
      self.printQrcodeRowDF = true;
    },
    printQrcodeRowSubmit() {
      const self = this;
      self.printFunction(self.printType);
      self.printQrcodeRowDF = false;
      self.selectRecords = [];
    },
    //
    batchAction(type) {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }

      if (type == "batchQuality") {
        this.batchQualityDF = true;
      }
      if (type == "batchQualityPush") {
        this.batchQualityPushDF = true;
      }
      if (type == "batchQualityDelivery") {
        for (const row of this.selectRecords) {
          if (!row.canQualityAndDeliver) {
            self.$message({
              message: "存在库存备货的或者库存返工或返工的产品，不能质检并发货",
              type: "warning",
            });
            return;
          }
        }
        this.batchQualityDeliveryDF = true;
      }
    },
    batchActionClose() {
      this.loadData();
      this.batchQualityDF = false;
      this.batchQualityPushDF = false;
      this.batchQualityDeliveryDF = false;
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (row.quantity > row.qualityQuantity + row.reworkQuantity) {
        return true;
      }
      return false;
    },
    //
    dataProvider(params) {
      return Quality.search(params);
    },
  },
};
</script>
